import { ofType } from "redux-observable";
import { ajax } from "rxjs/ajax";
import { of } from "rxjs";
import { mergeMap, catchError, switchMap } from "rxjs/operators";
import Tracker from "../utils/piwik";
import { FETCH_CBOOK_BEGIN, fetchCBookSuccess, logError, loadAPI, fetchClaims, fetchBonusMaterial, fetchLocale } from "../actions";
import sources from "../utils/JsonSources";
import { getAjaxSettings } from "../utils/getAjaxSettings";
import handleAjaxError from "../utils/handleAjaxError";
export default function fetchCBookEpic(action$, state$) {
    return action$.pipe(ofType(FETCH_CBOOK_BEGIN), mergeMap(function(action) {
        return ajax(getAjaxSettings(sources.treePath, state$.value)).pipe(switchMap(function(param) {
            var response = param.response;
            if (!response) {
                location.href = "/";
                return [];
            }
            document.title = response.name;
            document.body.classList.add("custom-root-".concat(response.slug));
            Tracker.setCustomDimension(1, response.theme_package_id);
            Tracker.trackEvent("cBook Loaded", "".concat(response.name, ": ").concat(response.default_ui_language, ", storyMode: ").concat(response.storyMode));
            return [
                fetchCBookSuccess({
                    cbook: response
                }),
                fetchLocale({
                    locale: response.default_ui_language || "en"
                }),
                loadAPI(),
                fetchClaims(),
                fetchBonusMaterial()
            ];
        }), catchError(function(error) {
            return handleAjaxError(error, "fetch_cbook", action);
        }));
    }), catchError(function(error) {
        return of(logError({
            error: error,
            key: "fetch_cbook"
        }));
    }));
}
